import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";
import { getMessaging } from "firebase/messaging";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

let firebaseConfig;

switch(process.env.VUE_APP_FIREBASE_CONFIG) {
  case "prod":
    firebaseConfig = {
      apiKey: "AIzaSyC1gzPeyWdFYi01ngmHOAfp2cojO61bwWk",
      authDomain: "concorsando-test.firebaseapp.com",
      databaseURL: "https://concorsando-test.firebaseio.com",
      projectId: "concorsando-test",
      storageBucket: "concorsando-test.appspot.com",
      messagingSenderId: "582664110079",
      appId: "1:582664110079:web:e0afd8877053be39aef1ca",
      measurementId: "G-WGGSNWQ0MN"
    };
    break;
  default:
    firebaseConfig = {
      apiKey: "AIzaSyC1gzPeyWdFYi01ngmHOAfp2cojO61bwWk",
      authDomain: "concorsando-test.firebaseapp.com",
      databaseURL: "https://concorsando-test.firebaseio.com",
      projectId: "concorsando-test",
      storageBucket: "concorsando-test.appspot.com",
      messagingSenderId: "582664110079",
      appId: "1:582664110079:web:e0afd8877053be39aef1ca",
      measurementId: "G-WGGSNWQ0MN"
    };
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(`${process.env.BASE_URL}firebase-messaging-sw.js`)
    .then(() => console.log("SW registrato correttamente"))
    .catch(err => console.log("Errore SW:", err));
}

const app = initializeApp(firebaseConfig);

// Inizializza App Check solo se abbiamo una chiave, per evitare 400 Bad Request
let appCheck = null;
const reCaptchaKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

if (reCaptchaKey) {
    appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(reCaptchaKey),
        isTokenAutoRefreshEnabled: true
    });
}

const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export { app, analytics, messaging, appCheck };
